// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1Kfu4","label":"Category_label__2I5Nd","content":"Category_content__2vRkV","header":"Category_header__fQ3q-","location":"Category_location__1Mol3"};